<div id="codelistCard" class="control-card-white">
  <div class="control-card-header">
    <ng-container i18n="@@codelisteditor_title">Codici d'attivazione</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div class="control-card-content" id="cardContent">
    <div class="table-container">
      <div class="scrollable-wrapper">
        <table class="simple-table">

          <thead>
            <th i18n="@@codelisteditor_code" style="width: 20%;">Codice</th>
            <th i18n="@@codelisteditor_description" style="width: 40%;">Descrizione</th>
            <th></th>
            <th i18n="@@codelisteditor_date" style="width: 40%;">Data d'attivazione</th>
            <th></th>
          </thead>

          <tbody [formGroup]="activationCodesForm">



            <ng-container formArrayName="items" id="codesTable">


              <tr *ngFor="let itemForm of items.controls; index as i">

                <ng-container [formGroup]="itemForm">

                  <td>
                    <label class="formElement">{{itemForm.value.code}}</label>
                  </td>

                  <td>
                    <label class="formElement">{{itemForm.value.description}}</label>
                  </td>

                  <td>
                    <div class="io-table-buttons">
                      <fa-icon icon="pen" class="icon-clickable" (click)="editItem(i)">
                      </fa-icon>
                    </div>
                  </td>

                  <td>
                    <label class="formElement">{{itemForm.value.date}}</label>
                  </td>

                  <td>
                    <div class="io-table-buttons">
                      <fa-icon icon="minus-circle" class="icon-clickable" (click)="deleteItem(i)">
                      </fa-icon>
                    </div>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </tbody>

          <tr>
            <td colspan="4">
              <div class="io-table-buttons">
                <fa-icon icon="plus-circle" class="icon-clickable" (click)="createNewCode()">
                </fa-icon>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <app-loading-screen #activationcodeloader [loading]="false"></app-loading-screen>
</div>
